<template>
    <div>
        <div>
            <div class="ur-lnb__menu-list-wrapper">
                <div class="new_campaign_button" v-if="showNewCampagin === true">
                    <ur-button full borderless solid primary @click="onClickNewCampagin">
                        <i class="new_campagin_icon_w"/>
                        캠페인 만들기
                    </ur-button>
                </div>
                <aicc-lnb-menu :menuItems="menuItems" :depth="1"/>
            </div>
        </div>
    </div>
</template>
<script>
import aiccLnbMenu from './AICCLnbMenu';

export default {
    name: 'aicc-lnb',
    components: {
        aiccLnbMenu,
    },
    props: {
        showNewCampagin: {
            type: Boolean,
            default: false,
        },
        showMyTrial: {
            type: Boolean,
            default: false,
        },
        menuItems: {
            type: Array,
            default: () => [],
        },
        collapsed: {
            type: Boolean,
            default: false,
        },
    },
    provide() {return {side: this.sharedData}},
    data() {
        return {
            currMenu:null,
        }
    },
    created(){},
    mounted(){},
    computed:{
        sharedData(){
            let rtn = {}, odf = Object.defineProperty;
            odf(rtn, "clickMenu", {get:()=>this.clickMenu});
            odf(rtn, "currMenu", {get:()=>this.currMenu});
            return rtn;
        },
    },
    watch:{},
    methods:{
        clickMenu(menu){
            this.currMenu = menu;
            //console.log('LNB clickMenu', menu);
            if (menu.menuTypeCode === 'L') {
                http.getLinks(menu.linkId).then(res => {
                    window.open(res.data.linkUrl, '_blank', res.data.linkPopupOptionValue);
                    }
                );
            } else {
                const forceRedirect = utils.getConfigurationValue('CFG_CMP_MENU_CLICK_RELOAD_YN') === 'Y';
                if (!menu.pageId || menu.pageId.trim() === '' || !menu.pageId.startsWith('PGE')) {
                    return;
                }
                const path = `/${menu.pageId}`;
                if (menu.pagePopupYn === 'Y') {
                    const popupOptions = menu.pagePopupOptionValue ? JSON.parse(menu.pagePopupOptionValue) : {};
                    let wnd = null;
                    wnd = utils.openWindowPopup(menu.pageId, null, null, popupOptions);
                    if (['PGE_CML_00007'].indexOf(menu.pageId) >= 0) {
                        wnd.addEventListener('beforeunload', e => {
                            if (wnd.CLOSE_SILIENTLY) {
                                delete e.returnValue;
                                this.$router.push({ path: `/${wnd.TARGET_PAGEID}`, query: { refresh: true } });
                            } else {
                                e.preventDefault();
                                e.returnValue = 'do not close siliently';
                            }
                        });
                    }
                } else if (forceRedirect) {
                    this.$router.push({
                        path: '/Redirect',
                        query: { pageId: menu.pageId },
                    });
                } else {
                    this.$router.push({ path });
                }
            }
            
            this.$store.commit('setMenuPath', []);
            if (menu.applicationId) {
                this.addMenuLog(menu);
                this.saveMenuPath(menu);
            }
        },
        setMenu(menu){
            this.currMenu = menu;
            this.$store.commit('setMenuPath', []);
            if (menu.applicationId) {
                this.addMenuLog(menu);
                this.saveMenuPath(menu);
            }
        },
        
        addMenuLog(menu) {
            http.request('LNBTree', 'DTS_CMP_00030', {
                data: {
                    menuLogTypeCode: 'MENU',
                    menuLogObjectId: menu.menuUid,
                    menuName: menu.menuName,
                    pageId: menu.pageId,
                    appId: menu.applicationId,
                },
            }).then(res => {
                if (!this.lnbMenuActivated) {
                    //this.updateMyMenu();
                }
            }).catch(err => {
                console.warn(err);
            });
        },

        saveMenuPath(menu) {
            const menuPath = [];
            menuPath.push({
                menuName: menu.menuName,
                menuUid: menu.menuUid,
                applicationId: menu.applicationId,
                portalId: menu.portalId,
                pageId: menu.pageId,
            });
            let parent = menu.parent || null;
            while (parent) {
                menuPath.splice(0, 0, {
                    menuName: parent.data.menuName,
                    menuUid: parent.data.menuUid,
                    applicationId: parent.data.applicationId,
                    portalId: parent.data.portalId,
                    pageId: '',
                });
                parent = parent.parent || null;
            }
            this.$store.commit('setMenuPath', menuPath);
        },
        onClickNewCampagin(){
            let isCurrent = false;
            const children = this.getComponent('aicc-frame').$children;
            for(let index in children) {
                const currentChild = children[index];
                if(currentChild.$options.name === 'PGE_AIC_00004') {
                    isCurrent = true;
                    currentChild.registerOutCallSchedule();
                    break;
                }
            }
            if(isCurrent === false) {
                aiccUtils.newOutCallSchedulePopup('I', '', (event) => {this.onNewCampaginClose()});
            }
            /*
            const component = this.getComponent('aicc-frame');
            const children = component.$children;
            for(let index in children) {
                const currentChildren = children[index];
                if(currentChildren.$options.name === 'PGE_AIC_00004') {
                    currentChildren.registerOutCallSchedule();
                    break;
                }
            }
            */
        },
        onNewCampaginClose(){
            let outCallSchduleInfoFromChild = window.getOutCallSchduleInfoFromChild();
            let modeValueFromChild = window.getModeValueFromChild();
            if (!outCallSchduleInfoFromChild || !outCallSchduleInfoFromChild.scheduleId) {
                return;
            }
            // 캠페인 상태 변경시에는 modeValueFromChild 값이 'statusChanged'로 넘어오지만 
            // 변경되었다는 것을 이미 알려줬기 때문에 여기서는 메시지 보여주지 않고 리스트만 갱신한다.

            let scheduleName = '';
            if (!utils.isEmpty(outCallSchduleInfoFromChild.scheduleName)) {
                scheduleName = "'" + outCallSchduleInfoFromChild.scheduleName + "'";
            }
            if (modeValueFromChild === 'I' || modeValueFromChild === 'C') {
                //this.showSnackbar(utils.strFormat("{0} 캠페인이 등록되었습니다.", scheduleName));
                this.getComponent('aicc-frame').showSnackBar(utils.strFormat("{0} 캠페인이 등록되었습니다.", scheduleName));
            }
            // 등록/수정화면에서 registerCancelModal 이 뜬 상태에서 '확인'하고 넘어오면
            // modeValueFromChild 값에 'Cancel'이 붙어온다.
            if (modeValueFromChild.substr(1,6) === 'Cancel') {
                this.getComponent('aicc-frame').showSnackBar(utils.strFormat("작업이 취소되었습니다."));
                //this.showSnackbar(utils.strFormat("작업이 취소되었습니다."));
            }
            window.setOutCallSchduleInfoFromChild('', '');
            //this.campaignValue = [];
            //this.campaignDropdown = [];
            /*
            const children = this.getComponent('aicc-frame').$children;
            for(let index in children) {
                const currentChild = children[index];
                if(currentChild.$options.name === 'PGE_AIC_00004') {
                    currentChild.getOutCallSchedulesForDateChange();
                    break;
                }
            }
            */
            //this.getOutCallSchedulesForDateChange();
        },
        getComponent(name) {
            let component = null;
            let thisComponent = this;
            while(thisComponent && !component) {
                if(thisComponent.$options.name === name) {
                    component = thisComponent;
                    break;
                }
                thisComponent = thisComponent.$parent;
            }
            return component;
        },
        /*
        updateMyMenu() {
            http.getFavoriteMenu().then(bookMark => {
            http.getRecentelyUsedMenu().then(receltylUsed => {
            this.mymenuItems = [receltylUsed, bookMark];

            this.$refs['treeview-custom'].expandAll();
            }).catch(e => {});
            }).catch(e => {});
        },
        */

    },
}
</script>
<style scoped>
    .ur-lnb__menu-list-wrapper {
        margin-top: 32px;
    }
    .new_campaign_button {
        height: 40px;
        margin: 0px 32px 24px 32px;
    }
    .ur-button--medium {
        height:100%;
        border-radius: 4px;
    }
    /*
    .ur-button--borderless, .ur-button--hyperlink {
        background-color: #516AF4;
        color:#FFF;
    }
    */
    /*
    .new_campagin_icon {
        width: 16px;
        height: 16px;
        display: inline-block;
        top: 3px;
        position: relative;
        background-image: url('../../../../assets/images/aicc/ic_campaign.png');
    }
    */
    .my_trial {
        position: absolute;
        bottom: 32px;
        width: 100%;
        text-align: center;
    }
    .my_trial > p {
        margin-bottom: 12px;
        font-weight: 500;
        color: #5A5A5A;
    }
    .my_trial > .ur-button--medium {
        width: 208px;
        height: 40px;
        line-height: 38px;
        padding: 0 16px;
    }
</style>